import React from 'react';
import AnimatedPage from '../../components/AnimatedPage';
import Img from '../../assets/images/Sinh_Trac_2.png';
import {motion} from 'framer-motion';
import { BackButton } from '../../components/BackButton';

const BiometricTablet = () => {
  return (
    <AnimatedPage animationType="fade">
      <div
        style={{
         width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <BackButton />
        <motion.img
          src={Img}
          alt="Digibank"
          initial={{opacity: 0, scale: 0.8}}
          animate={{opacity: 1, scale: 1}}
          transition={{delay: 0.1, duration: 0.5, ease: 'easeOut'}}
          style={{
            width: '90%',
            height: '90%',
            objectFit: 'contain',
            display: 'block',
          }}
        />
      </div>
    </AnimatedPage>
  );
};

export default BiometricTablet;
